<template>
  <div :class="['black--text font-weight-medium', fontSize]">
    <slot name="default" />
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fontSize() {
      const size = {
        true: "text-body-1 text-sm-h6",
      };

      return size[this.small] || "text-h6 text-sm-h5";
    },
  },
};
</script>
